module.exports = "@import &#x27;../variables&#x27;; .LiftingParamtersPane { padding-top: 20px; @include mobile { margin-bottom: -20px; } &amp;-field { margin-right: 25px; @include mobile { margin-right: 0; margin-bottom: 20px; }; } &amp;-service { padding-top: 20px; margin-top: 25px; border-top: 1px dashed #e9e8e5; display: flex; flex-wrap: wrap; } &amp;-serviceBlock { margin-left: 20px; @include mobile { margin: 15px 0 0 0; } } }"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ParametersScreen/LiftingParamtersPane.scss
// module id = 2023
// module chunks = 0